import { __rest } from "tslib";
import React from "react";
import * as S from "./styles";
export var H2 = function H2(t) {
  var e = t.children,
      r = __rest(t, ["children"]);

  return React.createElement(S.H2, Object.assign({}, r), e);
};
export default H2;